module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_allenamento-7bb49915192a11ef2f82fd18ec637c23.svg";